export default "__VITE_ASSET__BHwWwuei__"